import { joinStrings } from '@afterpay/utils'
import { useDate } from '@afterpaytouch/form/lib/utils/date'
import { useTranslation } from 'next-i18next'
import React from 'react'
import { ProfileCard } from '../..'
import { useConsumerSelector } from '../../../state'

export const HardIdProfileCard: React.FC = () => {
  const consumer = useConsumerSelector()
  const profileCardName = joinStrings([consumer.profile?.givenNames ?? '', consumer.profile?.surname ?? ''])
  const consumerDOB = consumer.profile?.dateOfBirth ?? ''
  const showDOB = consumerDOB.length > 0
  const { parseISODateString } = useDate('DD/MM/YYYY')
  const { t } = useTranslation()
  const { formattedDate } = parseISODateString(consumerDOB)
  const dobSubHeader = formattedDate.length > 0 ? t('verifyIdentity:partialVerified:dobLabel', { dob: formattedDate }) : undefined

  return <ProfileCard header={profileCardName} hideSubheader={!showDOB} customSubheader={dobSubHeader} />
}
